import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputFileAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['type', HTTPINPUTTYPE.FILE]
]);
export const inputFileData = makeDataStruct([]);
export const inputFileModel = makeStruct([
    ['attributes', inputFileAttr],
    ['data', inputFileData]
]);
// Class
export default class INPUTFILE extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
    activate(event) { }
    deactivate(event) { }
}
